import { render } from "./FlatsList.vue?vue&type=template&id=ab6be918&scoped=true"
import script from "./FlatsList.vue?vue&type=script&lang=js"
export * from "./FlatsList.vue?vue&type=script&lang=js"

import "./FlatsList.vue?vue&type=style&index=0&id=ab6be918&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6be918"]])

export default __exports__